import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../utils/commonQueryTypes";
import {empType} from "../../../../../utils/Enum.types";
import {AtsCompany} from "../../../customer/companies/queries/types";
import {
  AtsSubsidiary,
  AtsSubsidiarySite,
} from "../../masters/subsidary/queries/types";

export enum EmpMasterOrderField {
  NAME = "NAME",
}
export enum EmpQueryType {
  ALL = "ALL",
  BY_TYPE = "BY_TYPE",
  OTHER_THAN_SYS_ADMIN = "OTHER_THAN_SYS_ADMIN",
  ASSOICATED_VENDOR_USERS = "ASSOICATED_VENDOR_USERS",
  NOT_ASSOICATED_VENDOR_USERS = "NOT_ASSOICATED_VENDOR_USERS",
  LOGIN_STATUS_ACTIVE = "LOGIN_STATUS_ACTIVE",
  LOGIN_STATUS_INACTIVE = "LOGIN_STATUS_INACTIVE",
}

export interface EmpQueryData {
  queryType: EmpQueryType;
  empType: empType[];
  ldgrID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
}

export interface GetEmpVars extends commonPaginationTypes {
  customer_id: number;
  input: EmpQueryData;
  orderBy: {
    direction: OrderDirection;
    field: EmpMasterOrderField;
  };
  name: string;
  kgidValue?: number;
}

export interface EmpMaster {
  id: number;
  kgid: number;
  metalNo: number;
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  email: string;
  mobile: string;
  rights: string;
  lastAccessed: string;
  empType: empType;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  customer: {
    name: string;
  };
  isLoginCreated: boolean;
  company: AtsCompany;
  subsidiary: AtsSubsidiary;
  site: AtsSubsidiarySite;
  customerID: number;
}

export interface EmpMasterEdge {
  node: EmpMaster;
  cursor: string;
}

interface GetEmpData {
  edges: EmpMasterEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetEmpResult {
  GetEmp: GetEmpData;
}

//Mutations

interface CreateEmpMasterInput {
  name: string;
  kgid: number;
  metalNo: number;
  address: string;
  place: string;
  state: string;
  pin: string;
  mobile: string;
  email: string;
  empType: empType;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
}

interface UpdateEmpMasterInput {
  name: string;
  kgid: number;
  metalNo: number;
  address: string;
  place: string;
  state: string;
  pin: string;
  mobile: string;
  email: string;
  empType: empType;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
}

export interface AddEmpMasterVar extends commonMutationTypes {
  input: CreateEmpMasterInput;
  customer_id: number;
}

export interface AddEmpMasterResult {
  AddEmpMaster: boolean;
}

export interface UpdateEmpMasterVar extends commonMutationTypes {
  input: UpdateEmpMasterInput;
  emp_id: number;
  customer_id: number;
}

export interface UpdateEmpMasterResult {
  UpdateEmpMaster: boolean;
}

export type GetEmployeeByAuthIdResult = {
  GetEmployeeByAuthId: {
    id: number;
    name: string;
    address: string;
    place: string;
    state: string;
    pin: string;
    email: string;
    mobile: string;
    rights: string;
    lastAccessed: string;
    userType: string;
    customerID: number;
    empType: empType;
  };
};

interface ImportEmpData {
  name: string;
  companyName: string;
  subsidiaryName: string;
  siteName: string;
  mobileNo: string;
  kgid: number;
  metalNo: number;
  empType: empType;
}

export interface ImportEmpResult {
  ImportEmp: boolean;
}

export interface ImportEmpVariables {
  token?: String;
  customerID: number;
  input: ImportEmpData;
  user_details: userDetails;
}

export interface ExportEmpTemplateResult {
  ExportEmpTemplate: string;
}

export interface ExportEmpTemplateVars {
  token?: string;
  customerID: number;
}

export interface ValidateEmpForImportResult {
  ValidateEmpForImport: boolean;
}

export interface ValidateEmpForImportVar {
  token?: string;
  customerID: number;
  input: ImportEmpData;
}
